import { PaymentDestination } from '../interfaces/lease-ledger.interface'

/**
 * Las letras de un destino del pago (B-039): TODAS las que recibieron dinero, queden saldadas o no.
 *
 * El API manda `letters` con cada letra y lo que le tocó. Mientras convivan versiones —el panel nuevo
 * contra un API que aún no lo manda— se cae a `n`, que es la primera. Una letra que no se pudo resolver
 * (`n` nulo) se omite: inventar un número sería peor que no nombrarlo.
 */
export function destinationLetterNumbers(d: Pick<PaymentDestination, 'n' | 'letters'>): number[] {
  const fromList = (d.letters ?? []).map((l) => l.n).filter((n): n is number => n !== null && n !== undefined)
  const source = fromList.length ? fromList : d.n !== null && d.n !== undefined ? [d.n] : []
  return [...new Set(source)].sort((a, b) => a - b)
}

/**
 * El reparto por letra que vale la pena pintar: solo cuando el pago tocó más de una letra. Con una sola,
 * el encabezado del destino ya dice la letra y el monto, y repetirlo abajo es ruido.
 */
export function destinationLetterBreakdown(d: Pick<PaymentDestination, 'letters'>): Array<{ n: number | null; amount: number }> {
  const rows = d.letters ?? []
  return rows.length > 1 ? rows : []
}
